/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useCallback, useContext, useState } from "react";
import debounce from "lodash.debounce";
import { useTranslation } from "react-i18next";
import { SettingsFormatEdit } from "cms/fields/layout/controls/settings-format";
import { SettingsStyleEdit } from "cms/fields/layout/controls/settings-style";
import { SettingsTargetEdit } from "cms/fields/layout/controls/settings-targets";
import { useSelectFieldSchema } from "cms/fields/dynamic-field";
import DisplaySettingsWrapper from "cms/fields/layout/display-settings-wrapper";
import { ListItemContext } from "cms/fields/field-lists/field-list-context";
import Link from "./link";

const LinkFieldItemEdit = () => {
    
    const {
        type,
        name,
        index,
        value,
        settings,
        updateListItem,
        disabled = false
    } = useContext(ListItemContext);
    
    const { t } = useTranslation();
    // const throttler = useThrottle()
    const schema = useSelectFieldSchema(name);
    const { settings: schemaSettings } = schema || {};
    const { options: schemaOptions, styleOptions, formatOptions } = schemaSettings || {};
    
    const initialState = {
        value: value ? value : "",
        settings
    };
    const [itemLocalState, setItemLocalState] = useState(initialState);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const update = useCallback(
        debounce((updateState, index) => {
            updateListItem(updateState, index);
        }, 500),
        [updateListItem]
    );
    
    return (
        <Fragment>
            <div className='simplicity-composer-field-primary-layout'>
                <div className='simplicity-composer-field-primary'>
                    {/*<Grid item xl={6} lg={6} md={6} sm={6} xs={6}>*/}
                    <Link
                        key={`link-${index}`}
                        index={index}
                        value={value}
                        localState={itemLocalState}
                        setLocalState={setItemLocalState}
                        update={update}
                    />
                    {/*</Grid>*/}
                </div>
                <DisplaySettingsWrapper>
                    {/*  Reads from schema options.styleOptions */}
                    {/*  records selection as value settings.style */}
                    <SettingsStyleEdit
                        type={type}
                        name={name}
                        label={t("commons.displayStyle")}
                        itemLocalState={itemLocalState}
                        setItemLocalState={setItemLocalState}
                        disabled={disabled}
                        styleOptions={styleOptions}
                        selected={itemLocalState?.settings?.style}
                        index={index}
                        update={update}
                    />
                    {/*  Reads from schema options.formatOptions */}
                    {/*  records selection as value settings.format */}
                    <SettingsFormatEdit
                        type={type}
                        name={name}
                        label={t("commons.displayAs")}
                        itemLocalState={itemLocalState}
                        setItemLocalState={setItemLocalState}
                        disabled={disabled}
                        formatOptions={formatOptions}
                        selected={itemLocalState?.settings?.format}
                        index={index}
                        update={update}
                    />
                    {/*  Reads from schema options.targets */}
                    {/*  records selection as value settings.options.openIn */}
                    <SettingsTargetEdit
                        type={type}
                        name={name}
                        label={t("commons.openIn")}
                        itemLocalState={itemLocalState}
                        setItemLocalState={setItemLocalState}
                        disabled={disabled}
                        schemaOptions={schemaOptions}
                        selected={itemLocalState?.settings?.options?.openIn}
                        index={index}
                        update={update}
                    />
                </DisplaySettingsWrapper>
            </div>
        </Fragment>
    );
};
LinkFieldItemEdit.displayName = "LinkFieldItemEdit";
export { LinkFieldItemEdit };


/*
{
    "label":"Links",
    "description": "Add related web content links",
    "defaultValue": null,
    "noOverride": false,
    "hidden": false,
    "required": true,
    "placeholder": "Add a link with text and a URL",
    "defaultStyle": "field.style.body",
    "defaultFormat": "field.format.text-only",
    "styleOptions": [
        { "name": "Body", "value": "field.style.body" },
        { "name": "Heading 1", "value": "field.style.h1" },
        { "name": "Heading 2", "value": "field.style.h2" },
        { "name": "Heading 3", "value": "field.style.h3" },
        { "name": "Heading 4", "value": "field.style.h4" }
    ],
    "formatOptions": [
        { "name": "Text", "value": "field.link.text-only" },
        { "name": "Text & Icon", "value": "field.link.text-icon" },
        { "name": "Icon Only", "value": "field.link.icon-only" }
    ],
    "options": {
        "targets": [
            { "name": "Open in new tab", "value": "field.target.tab" },
            { "name": "Replace current", "value": "field.target.self" }
        ]
    }
}
*/
